import React, { forwardRef, useEffect, useState } from 'react';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { useListFacesPageFilters } from '../../../useListDetailsFilters';

function FaceIdsFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const [error, setError] = useState(undefined);
  const { filters, updateFilters, updateFiltersDebounced } = useListFacesPageFilters();

  const onChangeHandler = (face_ids: string) => {
    setLocalValue(face_ids);

    if (typeof validate.multipleUuid()(face_ids) === 'string') {
      setError(validate.multipleUuid()(face_ids));
      return;
    }

    setError(undefined);
    updateFiltersDebounced({ face_ids });
  };

  useEffect(() => {
    setLocalValue(filters.face_ids ?? '');
  }, [filters]);

  const reset = () => {
    updateFilters({ face_ids: undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('list-details-page:filters.popovers.face_ids')}</div>}
    >
      <Control.Input
        errorMessage={error}
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const FaceIdsFilterPopoverWithRef = forwardRef(FaceIdsFilterPopover);
export { FaceIdsFilterPopoverWithRef as FaceIdsFilterPopover };
